export enum SlideId {
  organisation = 'organisation',
  customers = 'customers',
  softwareDev = 'softwareDev',
  supplyChain = 'supplyChain',
  cyberInsurance = 'cyberInsurance',
  regulations = 'regulations',
  assessmentDetails = 'assessmentDetails',
  scenarios = 'scenarios',
  finalise = 'finalise',
  customControls = 'recommenderControls',
}

export enum RecomendedControlsSlideId {
  scenarios = 'scenarios',
  controls = 'controls',
  link = 'link',
}

export interface FormValuesScenarios {
  B2B: boolean;
  B2C: boolean;
  publiclyAccessibleInternetBusiness: boolean;
  paymentVolumeOrValue: boolean;
  significantITContributionToRevenue: boolean;
  significantDataInCloud: boolean;
  softwareBusiness: boolean;
  cniOrDefenseInvolvement: boolean;
  significantRandD: boolean;
  regulated: boolean;
  operationalTechnology: boolean;
  supplyChainReliant: boolean;
  aiThirdPartyReliant: boolean;
  aiCustomerFacingApp: boolean;
}

export interface WizardFormValues {
  organisation: {
    sector?: CompanySector;
    usesManagedServiceProvider: boolean;
    annualRevenue?: number | null; //variable
    numberOfStaff?: number | null; //variable
    annualWageBill?: number | null; //variable
    avgWorkingDays?: number | null; //variable
    annualCyberSpend?: number | null; //variable
    avgStaffHardwareCost?: number | null; //variable
  };
  customers: {
    numberOfCustomers?: number | null; //variable
    avgContractValue?: number | null; //variable
    numberOfDataRecords?: number | null; //variable
  };
  softwareDev: {
    developsSoftware: boolean;
    releaseCycleCost?: number | null; //variable
    releaseCycleLength?: number | null; //variable
    researchAndDevelopmentBudget?: number | null; //variable
  };
  supplyChain: {
    avgCostToProcureSupplier?: number | null; //variable
    avgInvoiceValue?: number | null; //variable
    largestRegularInvoiceValue?: number | null; //variable
  };
  cyberInsurance: {
    cyberInsurance: boolean;
    cyberInsuranceLimit?: number | null; //variable
    cyberInsuranceExcess?: number | null; //variable
    cyberInsurancePremium?: number | null; //variable
  };
  regulations: {
    legislation: string[];
    controlFrameworks: string[];
    controlFrameworksOther: string[];
    primaryControlFramework?: string;
    primaryFrameworkControls: string[];
    pinnedControlFrameworks: string[];
  };
  scenarios: FormValuesScenarios;
  assessment: {
    id?: string;
    name?: string | null;
    description?: string | null;
    started_date?: string | null;
    review_date?: string | null;
  };
}

export interface WizardRecomendedControlsFormValues {
  scenarios: FormValuesScenarios;
  selectedControls: Record<string, Record<string, boolean>>; // controlId -> scenarioId -> isSelected
  addRecommendedModifiers: boolean;
}

// ----------------------------------------------------   Company sector
export enum CompanySector {
  AEROSPACE_AND_DEFENCE = 'AEROSPACE_AND_DEFENCE',
  AGRICULTURE_FORESTRY_AND_FISHING = 'AGRICULTURE_FORESTRY_AND_FISHING',
  AUTOMOBILES_AND_PARTS = 'AUTOMOBILES_AND_PARTS',
  BANKS = 'BANKS',
  BASIC_RESOURCES = 'BASIC_RESOURCES',
  CHEMICALS = 'CHEMICALS',
  CONSTRUCTION_AND_MATERIALS = 'CONSTRUCTION_AND_MATERIALS',
  CONSUMER_PRODUCTS_AND_SERVICES = 'CONSUMER_PRODUCTS_AND_SERVICES',
  EDUCATION = 'EDUCATION',
  ENERGY = 'ENERGY',
  FINANCIAL_SERVICES = 'FINANCIAL_SERVICES',
  FOOD_BEVERAGE_AND_TOBACCO = 'FOOD_BEVERAGE_AND_TOBACCO',
  GOVERNMENT = 'GOVERNMENT',
  HEALTH_CARE = 'HEALTH_CARE',
  INDUSTRIAL_GOODS_AND_SERVICES = 'INDUSTRIAL_GOODS_AND_SERVICES',
  INSURANCE = 'INSURANCE',
  MEDIA = 'MEDIA',
  NON_PROFIT_CHARITIES = 'NON_PROFIT_CHARITIES',
  PERSONAL_CARE_DRUG_AND_GROCERY_STORES = 'PERSONAL_CARE_DRUG_AND_GROCERY_STORES',
  PROFESSIONAL_SERVICES = 'PROFESSIONAL_SERVICES',
  REAL_ESTATE = 'REAL_ESTATE',
  RETAIL = 'RETAIL',
  TECHNOLOGY = 'TECHNOLOGY',
  TELECOMMUNICATIONS = 'TELECOMMUNICATIONS',
  TRANSPORTATION_AND_LOGISTICS = 'TRANSPORTATION_AND_LOGISTICS',
  TRAVEL_AND_LEISURE = 'TRAVEL_AND_LEISURE',
  UTILITIES = 'UTILITIES',
}

export const companySectorNaming: Record<CompanySector, string> = {
  [CompanySector.AEROSPACE_AND_DEFENCE]: 'Aerospace and Defence',
  [CompanySector.AGRICULTURE_FORESTRY_AND_FISHING]: 'Agriculture, Forestry, and Fishing',
  [CompanySector.AUTOMOBILES_AND_PARTS]: 'Automobiles and Parts',
  [CompanySector.BANKS]: 'Banks',
  [CompanySector.BASIC_RESOURCES]: 'Basic Resources',
  [CompanySector.CHEMICALS]: 'Chemicals',
  [CompanySector.CONSTRUCTION_AND_MATERIALS]: 'Construction and Materials',
  [CompanySector.CONSUMER_PRODUCTS_AND_SERVICES]: 'Consumer Products and Services',
  [CompanySector.EDUCATION]: 'Education',
  [CompanySector.ENERGY]: 'Energy',
  [CompanySector.FINANCIAL_SERVICES]: 'Financial Services',
  [CompanySector.FOOD_BEVERAGE_AND_TOBACCO]: 'Food, Beverage and Tobacco',
  [CompanySector.GOVERNMENT]: 'Government',
  [CompanySector.HEALTH_CARE]: 'Health Care',
  [CompanySector.INDUSTRIAL_GOODS_AND_SERVICES]: 'Industrial Goods and Services',
  [CompanySector.INSURANCE]: 'Insurance',
  [CompanySector.MEDIA]: 'Media',
  [CompanySector.NON_PROFIT_CHARITIES]: 'Non-Profit / Charities',
  [CompanySector.PERSONAL_CARE_DRUG_AND_GROCERY_STORES]: 'Personal Care, Drug and Grocery Stores',
  [CompanySector.PROFESSIONAL_SERVICES]: 'Professional Services',
  [CompanySector.REAL_ESTATE]: 'Real Estate',
  [CompanySector.RETAIL]: 'Retail',
  [CompanySector.TECHNOLOGY]: 'Technology',
  [CompanySector.TELECOMMUNICATIONS]: 'Telecommunications',
  [CompanySector.TRANSPORTATION_AND_LOGISTICS]: 'Transportation and Logistics',
  [CompanySector.TRAVEL_AND_LEISURE]: 'Travel and Leisure',
  [CompanySector.UTILITIES]: 'Utilities',
};

export const companySectorOptions: { label: string; value: CompanySector }[] = Object.entries(companySectorNaming).map(
  ([value, label]) => ({
    value: value as CompanySector,
    label,
  }),
);
